export default __webpack_public_path__ + "static/media/agar.3ee4d448.png";